// material-ui
import { useTheme } from '@mui/material/styles';

import logoText from 'assets/images/logos/vaseelah-logo-text.svg';
import logoIcon from 'assets/images/icons/vaseelah-icon-new.svg';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const VaseelahLogo = ({ width, white }) => {
  const theme = useTheme();

  return (
    <div className="flex items-center jusitify-center gap-2">
      <img
        src={white ? 'assets/images/icons/vaseelah-icon-new.svg' : logoIcon}
        alt="vaseelah-icon"
        width={width ? width * 0.4 : 40}
        className="animate-[spin_30s_linear_infinite]"
      />
      <img src={white ? 'assets/images/logos/vaseelah-logo-text-white.svg' : logoText} alt="vaseelah-logo" width={width ? width : 120} />
    </div>
  );
};

export default VaseelahLogo;
